'use client';

import { c as _c } from "react/compiler-runtime";
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import * as React from 'react';
import { cn } from '@/lib/utils';
function TooltipProvider(t0) {
  const $ = _c(6);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      delayDuration: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const delayDuration = t1 === undefined ? 0 : t1;
  let t2;
  if ($[3] !== delayDuration || $[4] !== props) {
    t2 = <TooltipPrimitive.Provider data-slot="tooltip-provider" delayDuration={delayDuration} {...props} />;
    $[3] = delayDuration;
    $[4] = props;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function Tooltip(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <TooltipProvider><TooltipPrimitive.Root data-slot="tooltip" {...props} /></TooltipProvider>;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function TooltipTrigger(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
interface TooltipContentProps extends React.ComponentProps<typeof TooltipPrimitive.Content> {
  portalContainer?: React.ComponentProps<typeof TooltipPrimitive.Portal>['container'];
  showArrow?: boolean;
}
function TooltipContent(t0) {
  const $ = _c(20);
  let children;
  let className;
  let portalContainer;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      sideOffset: t1,
      children,
      portalContainer,
      showArrow: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = portalContainer;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    children = $[1];
    className = $[2];
    portalContainer = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const sideOffset = t1 === undefined ? 0 : t1;
  const showArrow = t2 === undefined ? false : t2;
  let t3;
  if ($[7] !== className) {
    t3 = cn("bg-primary text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-navigation w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance data-[state=closed]:duration-0", className);
    $[7] = className;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== showArrow) {
    t4 = showArrow && <TooltipPrimitive.Arrow className="bg-primary fill-primary z-navigation size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" />;
    $[9] = showArrow;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== children || $[12] !== props || $[13] !== sideOffset || $[14] !== t3 || $[15] !== t4) {
    t5 = <TooltipPrimitive.Content data-slot="tooltip-content" sideOffset={sideOffset} className={t3} {...props}>{children}{t4}</TooltipPrimitive.Content>;
    $[11] = children;
    $[12] = props;
    $[13] = sideOffset;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== portalContainer || $[18] !== t5) {
    t6 = <TooltipPrimitive.Portal container={portalContainer}>{t5}</TooltipPrimitive.Portal>;
    $[17] = portalContainer;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}
export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };